import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Home from './Home/Home';
import Single from './Single/Single';
import './App.css';

import { PostStoreProvider } from '../store/PostStore';

const App = () => {

    return(
        <PostStoreProvider>
            <BrowserRouter>
                <Switch>
                    <Route exact path="/" component={ Home } />
                    <Route exact path="/single/:id" component={ () => <Single /> } />
                </Switch>
            </BrowserRouter>
        </PostStoreProvider>
    );
}

export default App;